import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {UserManagementConstants} from '../../../constants'
import {convertSettingsJsonData} from './utils'
import * as EntitiesActionTypes from '../../../entities/actionTypes'
import {arrayToSet, filterArrayByKeys} from '../../../atUtils'

const WorkAssignmentsFilterValues = UserManagementConstants.WorkAssignmentsFilter

const createReducer = ({
    USER_MANAGEMENT = {}
}) => {
    const initialSettings = {
        usersFilter: {
            userIds: [],
            groupIds: [],
            groupType: null,
            allSelected: true,
        },
        workAssignmentsFilter: WorkAssignmentsFilterValues.ALL,
        sorting: {
            order: UserManagementConstants.USER_LIST_ORDER_BY_NAME,
            asc: true,
        },
        nUsersPerPage: 25,
        ...convertSettingsJsonData(USER_MANAGEMENT.WA_TAB_SETTINGS)
    }

    const initialState = {
        userIdsOrder: [],
        loaded: false,
        loading: false,
        usersWorkAssignmentsCounters: {},
        newUsersIdSet: {},
        wordsFilter: '',
        submittedWordsFilter: '',
        currentPageNum: 1,
        nTotalUsers: 0,
        ...initialSettings,
    }

    return handleActions({
        [ActionTypes.USER_IDS_ORDER_SET]: (state, {payload: userIdsOrder}) => ({
            ...state,
            userIdsOrder
        }),
        [ActionTypes.LOAD_USERS_DATA]: (state) => ({
            ...state,
            loading: true,
        }),
        [ActionTypes.SET_LOADING]: (state, {payload: isLoading}) => ({
            ...state,
            loading: isLoading,
        }),
        [ActionTypes.LOAD_USERS_DATA_SUCCESS]: (state, {payload: data}) => ({
            ...state,
            currentPageNum: data.currentPage,
            nTotalUsers: data.nTotalUsers,
        }),
        [ActionTypes.LOAD_USERS_DATA_FAILURE]: (state) => ({
            ...state,
            loading: false,
        }),
        [ActionTypes.SET_LOADED]: (state, {payload: loaded}) => ({
            ...state,
            loaded,
        }),
        [ActionTypes.SET_SORTING]: (state, {payload: sorting}) => ({
            ...state,
            sorting: sorting,
        }),
        [ActionTypes.SET_USERS_FILTER]: (state, {payload: usersFilter}) => ({
            ...state,
            usersFilter,
        }),
        [ActionTypes.SET_WORDS_FILTER]: (state, {payload: wordsFilter}) => ({
            ...state,
            wordsFilter,
        }),
        [ActionTypes.SET_USERS_PER_PAGE]: (state, {payload: usersPerPage}) => ({
            ...state,
            nUsersPerPage: usersPerPage,
        }),
        [ActionTypes.SET_PAGE_NUM]: (state, {payload: pageNum}) => ({
            ...state,
            currentPageNum: pageNum,
        }),
        [ActionTypes.SET_SUBMITTED_WORDS_FILTER]: (state, {payload: submittedWordsFilter}) => ({
            ...state,
            submittedWordsFilter,
        }),
        [ActionTypes.SET_WORK_ASSIGNMENTS_FILTER]: (state, {payload: workAssignmentsFilter}) => ({
            ...state,
            workAssignmentsFilter: workAssignmentsFilter,
        }),
        [ActionTypes.SET_USER_WORK_ASSIGNMENT_COUNTERS]: (state, {payload: userCounters}) => {
            const workCounters = state.userWorkAssignmentsCounters

            for (let userCounter of userCounters)
                workCounters[userCounter.id] = userCounter.counters

            return {
                ...state,
                userWorkAssignmentsCounters: workCounters,
            }
        },
        [ActionTypes.SET_USERS_WORK_ASSIGNMENTS_COUNTERS]: (state, {payload: usersWorkAssignmentsCounters}) => ({
            ...state,
            usersWorkAssignmentsCounters
        }),
        [ActionTypes.ADD_USER_WORK_ASSIGNMENTS_COUNTERS]: (state, {payload: additionalAssignments}) => ({
            ...state,
            usersWorkAssignmentsCounters: {
                ...state.usersWorkAssignmentsCounters,
                ...additionalAssignments,
            }
        }),
        [EntitiesActionTypes.USERS_REMOVE]: (state, {payload: ids}) => ({
            ...state,
            userIdsOrder: filterArrayByKeys(state.userIdsOrder, ids)
        }),
    }, initialState)
}

export default createReducer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentsTab/reducer.js